import { render, staticRenderFns } from "./subordinateDet.vue?vue&type=template&id=05e50b78&scoped=true"
import script from "./subordinateDet.vue?vue&type=script&lang=js"
export * from "./subordinateDet.vue?vue&type=script&lang=js"
import style0 from "./subordinateDet.vue?vue&type=style&index=0&id=05e50b78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e50b78",
  null
  
)

export default component.exports